// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader--1FjaT"};